<div class="alert-try-again">
    <span>{{text}}</span>
    <div class="fieldset">
      <core-helpers-forms-button [text]="textButton" (submit)="try()"></core-helpers-forms-button>
    </div>
</div>
